const isDisplayed = ({ adverts: { isDisplayed } }) => isDisplayed;

export default isDisplayed;
